/**
 * Build-time configuration flags for the web app.
 * Values come from Vite env vars (packages/web/.env for per-developer settings).
 */

/**
 * Shows the manual email/password login form on the sign-in page.
 * Dev-only escape hatch for running the web app locally without Microsoft SSO.
 * The `import.meta.env.DEV` guard guarantees the form is dead-code-eliminated
 * from production builds even if the env var is set.
 */
export const isLocalLoginEnabled =
  import.meta.env.DEV && import.meta.env.VITE_ENABLE_LOCAL_LOGIN === "true";
